import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function BundlesDetailsTab(props) {

    const { session } = useContext(SessionContext);
    const bundles = Array.isArray(props.bundles) ? props.bundles : [];
    const [loading, setLoading] = useState(true); // State to track loading status

    const bundlePriceRows = bundles.map((bundle, wgindex) => {
        return (
            <tr>
                <td><strong>{bundle.use_limit} workshops</strong></td>
                <td>€{bundle.price} ({bundle.discount_percent}% discount)</td>
                <td>
                    <form action="https://www.campfr.com/api/bundle_checkout" method="POST">
                        <input type="hidden" name="priceCode" value={bundle.price_id} />
                        <input type="hidden" name="ws" value={session.ws} />
                        <button className="confirm-process-button" type="submit">
                            Buy now
                        </button>
                    </form>
                </td>
            </tr>
        );
    });

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <h3 className="d-subtitle has-bg-image">Study more, save up to 30%</h3>
            <div className="workshop_bodytext has-bg-image">
                <p>Immerse yourself in multiple CAMP online workshops, build a wide array of skills and knowledge, and save up to 30% with an Online Workshop bundle!</p>

                <p>We're holding over 100 online workshops in 2025/2026, in a variety of subjects including musical performance, composition, production, sound, ecoacoustics, literature & writing, visual arts, digital arts, performance art, activism and much more.</p>

                <p>You get:</p><br />

                <ul>
                    <li>A unique booking code - use it to enrol in multiple workshops</li>
                    <li>Early access to all online workshops, to make sure you never miss out</li>
                    <li>As a special bonus, your code can also be used as a 10% discount on any CAMP onsite workshop in 2025!</li>
                </ul>

                <div className="bundle-prices">
                    <table className="bundles-table">
                        {bundlePriceRows}
                    </table>
                </div>
            </div>
        </div>
    );
}

export default BundlesDetailsTab;
